module.exports = __webpack_public_path__ + "img/icon_4.ea2d57b5.png";